import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { FileText } from "lucide-react";
import { TERMINOS_CONTRIBUYENTE, TERMINOS_VERSION, TERMINOS_FECHA } from "../data/terminos";

export function TerminosContent({ compact = false }) {
  return (
    <div className={compact ? "text-sm space-y-4" : "text-base space-y-6"} data-testid="terminos-content">
      <div className="rounded-lg bg-green-50 border border-green-200 p-3 text-xs">
        <p><b>Versión:</b> {TERMINOS_VERSION} · <b>Última actualización:</b> {TERMINOS_FECHA}</p>
      </div>
      {TERMINOS_CONTRIBUYENTE.map((section, i) => (
        <div key={i}>
          <h3 className="font-bold text-green-900 mb-1">{section.titulo}</h3>
          {section.parrafos?.map((p, j) => (
            <p key={j} className="text-slate-700 mb-2 leading-relaxed">{p}</p>
          ))}
          {section.items && (
            <ul className="list-disc list-outside pl-5 text-slate-700 space-y-1">
              {section.items.map((it, j) => <li key={j} className="leading-relaxed">{it}</li>)}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export function TerminosDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-hidden flex flex-col" data-testid="terminos-dialog">
        <DialogHeader>
          <DialogTitle className="text-green-900 flex items-center gap-2">
            <FileText className="w-5 h-5" />
            Términos y Condiciones — Portal Contribuyente SISAUR
          </DialogTitle>
          <DialogDescription className="text-xs text-slate-500">
            Léalos con atención antes de aceptarlos. Al aceptar, usted confirma haber leído y comprendido este documento.
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto pr-2 -mr-2" data-testid="terminos-scroll">
          <TerminosContent compact />
        </div>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} className="bg-green-700 hover:bg-green-800 text-white" data-testid="terminos-close-btn">
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
